const FinancialAccounts = {
    template: require('./financialAccounts.html'),
};

export default angular
    .module('mpdx.reports.financialAccounts.component', [])
    .component('financialAccounts', FinancialAccounts).name;
